(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    class LimitedEditionCountdown extends HTMLElement {
    connectedCallback() {
      const hours = parseFloat(this.dataset.durationHours) || 4;
      this.endDate = new Date(Date.now() + hours * 3600000);
      this.display = this.querySelector('.limited-edition-countdown__timer');

      if (!this.display) {
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      const now = new Date();
      const diff = Math.max(0, this.endDate - now);

      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      const pad = (n) => String(n).padStart(2, '0');
      this.display.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

      if (diff <= 0) {
        clearInterval(this.interval);
        this.style.display = 'none';
      }
    }
  }

  if (!customElements.get('limited-edition-countdown')) {
    customElements.define('limited-edition-countdown', LimitedEditionCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-timeline"] && !Shopify.designMode) return;
  try {
    class ShippingTimelineComponent extends HTMLElement {
    connectedCallback() {
      const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const formatDate = (date) =>
        WEEKDAYS[date.getDay()] + ' ' + String(date.getDate()).padStart(2, '0') + ' ' + MONTHS[date.getMonth()];

      const addDays = (base, days) => {
        const d = new Date(base);
        d.setDate(d.getDate() + days);
        return d;
      };

      const dispatchMin = parseInt(this.dataset.dispatchMin, 10) || 0;
      const dispatchMax = parseInt(this.dataset.dispatchMax, 10) || 0;
      const deliveryMin = parseInt(this.dataset.deliveryMin, 10) || 0;
      const deliveryMax = parseInt(this.dataset.deliveryMax, 10) || 0;

      const today = new Date();

      const orderEl = this.querySelector('[data-role="order-date"]');
      const dispatchEl = this.querySelector('[data-role="dispatch-date"]');
      const deliveryEl = this.querySelector('[data-role="delivery-date"]');

      if (orderEl) orderEl.textContent = formatDate(today);
      if (dispatchEl) {
        dispatchEl.textContent =
          formatDate(addDays(today, dispatchMin)) + ' – ' + formatDate(addDays(today, dispatchMax));
      }
      if (deliveryEl) {
        deliveryEl.textContent =
          formatDate(addDays(today, deliveryMin)) + ' – ' + formatDate(addDays(today, deliveryMax));
      }
    }
  }

  if (!customElements.get('shipping-timeline-component')) {
    customElements.define('shipping-timeline-component', ShippingTimelineComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuideComponent extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      const openBtn = this.querySelector('[data-size-guide-open]');
      const closeBtn = this.querySelector('[data-size-guide-close]');

      if (!this.dialog || !openBtn || !closeBtn) return;

      openBtn.addEventListener('click', () => this.dialog.showModal());
      closeBtn.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('size-guide-component')) {
    customElements.define('size-guide-component', SizeGuideComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
